import allImgPaths from "assets/images";
import React, { useEffect, useState } from "react";
import { recentActivities } from "services/event";
import { useNavigate } from "react-router-dom";
import useAppState from "context/useAppState";
import { RecentActivityLoader } from "components/loaders";

const RecentActivity = () => {
  const [recentActivitiesData, setRecentActivitiesData] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  const { setState: setEventListData, isEventListAPICall, showRecentActivitiesLoading } = useAppState("eventList");

  useEffect(() => {
    if (isEventListAPICall) {
      setTimeout(() => {
        const currentTeam = JSON.parse(
          localStorage.getItem("selectedTeam") as string
        );
        if (!currentTeam?.currentTeamId) {
          setTimeout(() => fetchData(), 3000);
        } else {
          fetchData();
        }
      }, 3000)
    }
  }, [isEventListAPICall]);

  const fetchData = async () => {
    const currentTeam = JSON.parse(
      localStorage.getItem("selectedTeam") as string
    );
    if (currentTeam?.currentTeamId) {
      const { data } = await recentActivities(currentTeam.currentTeamId);
      setRecentActivitiesData(data);
      setLoading(false);
      setEventListData({ showRecentActivitiesLoading: false })
    }
  };

  const handleClick = (event: any) => {
    if (event?.is_draft) {
      navigate(`/fete/new/${event?.event_id}`);
    } else {
      navigate(`/fete/${event?.event_id}`);
    }
  };

  const handleImageError = (e: any) => {
    e.target.src = allImgPaths.upcomingFeteIcon
  }

  const DraftCard = (item: any) => {
    const { event } = item;

    return (
      <>
        {/* Draft Card */}
        <div className="relative w-[336px] group" onClick={() => handleClick(event)}>
          <span className="hidden group-hover:block absolute top-0 left-0 bg-[#EAECF0] w-full h-full z-10 transform rotate-[-1.88deg] translate-y-[4px] -translate-x-[5px] rounded-lg"></span>
          <div className="flex gap-x-3 items-start relative z-20 bg-white rounded-lg py-3.5 px-3  cursor-pointer border border-[#FDA29B] w-full h-full">
            <img
              className="w-10 h-10 rounded-full object-cover"
              src={allImgPaths.draftIcon}
              alt=""
            />
            <div className="w-full">
              <div className="flex items-start justify-between w-full pb-1">
                <div className="relative group cursor-pointer">
                  <h4 title={event.event_name} className="text-[#1C222B] font-interSemiBold text-base line-clamp-1 max-w-[252px]">
                    {event.event_name}
                  </h4>

                </div>
              </div>
              <p className="text-sm text-[#475467]">Last visited {event.last_activity}</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className=''>
      <div className='bg-[#F9FAFB] pt-5 pb-7 px-10 border-b border-t border-[#EAECF0]'>
        <h3 className='text-[#101828] text-2xl font-interSemiBold pb-5'>
          Recent Activity{" "}
        </h3>
        <div className='flex gap-x-5 pb-2'>
          <RecentActivityLoader count={showRecentActivitiesLoading ? 2 : 0} />
          {!showRecentActivitiesLoading &&
            recentActivitiesData &&
            recentActivitiesData?.length > 0 &&
            recentActivitiesData.map((item: any, index: number) => (
              <React.Fragment key={index}>
                {item.is_draft && <DraftCard event={item} />}
                {!item.is_draft &&
                  <div className="relative w-[336px] group">
                    <span className="hidden group-hover:block absolute top-0 left-0 bg-[#EAECF0] w-full h-full z-10 transform rotate-[-1.88deg] translate-y-[4px] -translate-x-[5px] rounded-lg"></span>
                    <div
                      className='flex gap-x-3 items-start border bg-white border-[#D7DFE9] rounded-lg py-3.5 px-3 w-full h-full cursor-pointer relative z-20'
                      onClick={() => handleClick(item)}
                    >
                      <img
                        className='w-10 h-10 rounded-full object-cover'
                        src={item?.event_image || allImgPaths.upcomingFeteIcon}
                        alt=''
                        onError={handleImageError}
                      />
                      <div className='w-full'>
                        <div className='flex items-start justify-between w-full pb-1'>
                          <div className='relative group cursor-pointer'>
                            <h4 title={item?.event_name} className='text-[#1C222B] font-interSemiBold text-base line-clamp-1 max-w-[252px]'>
                              {item?.event_name}
                            </h4>
                          </div>
                        </div>
                        <p className='text-sm text-[#475467]'>
                          Last visited {item?.last_activity}
                        </p>
                      </div>
                    </div>
                  </div>
                }
              </React.Fragment>
            ))}
          {!showRecentActivitiesLoading && !recentActivitiesData?.length && (
            <div className="flex justify-center gap-x-12 items-center w-full">
              <img src={allImgPaths.recentActivityEmptyState} alt="" />

              <div className="text-center">
                <p className="font-interSemiBold text-base text-[#344054] pb-1">Nothing to show here!</p>
                <p className="text-base font-normal text-[#344054] mb-5">Have some fun! Go explore!</p>
                <button className="submit-btn-blue !px-5 !py-1.5 whitespace-nowrap !bg-white border !border-[#A59DFB] !text-[#1e0af5] hover:!bg-[#E8E6FE]" onClick={() => { }}>
                  Explore
                </button>
              </div>

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;
